import { render, staticRenderFns } from "./bannersList.vue?vue&type=template&id=5a02dfb2&scoped=true&"
import script from "./bannersList.vue?vue&type=script&lang=js&"
export * from "./bannersList.vue?vue&type=script&lang=js&"
import style0 from "./bannersList.vue?vue&type=style&index=0&id=5a02dfb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a02dfb2",
  null
  
)

export default component.exports